import { PDFDocument } from "pdf-lib";
import { pageLayout } from "./image-pdf-core.js";

export async function createImagePdf(items, options, prepareImage, onProgress = () => {}) {
  const document = await PDFDocument.create();
  document.setCreator("smallpdf.app");
  document.setProducer("smallpdf.app Images to PDF");

  for (let index = 0; index < items.length; index += 1) {
    onProgress(index + 1, items.length);
    const prepared = await prepareImage(items[index], options.quality);
    const layout = pageLayout(prepared.width, prepared.height, options);
    const page = document.addPage([layout.pageWidth, layout.pageHeight]);
    const embedded = prepared.type === "png"
      ? await document.embedPng(prepared.bytes)
      : await document.embedJpg(prepared.bytes);
    page.drawImage(embedded, { x: layout.x, y: layout.y, width: layout.width, height: layout.height });
  }

  return document.save({ useObjectStreams: true });
}
